export type ThemePreference = 'dark' | 'light' | 'system';
export type ResolvedTheme = 'dark' | 'light';

/** @deprecated Use ThemePreference / ResolvedTheme */
export type Theme = ResolvedTheme;

const STORAGE_KEY = 'da-theme';

export function getSystemTheme(): ResolvedTheme {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return 'dark';
  }
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

/** Stored user preference (defaults to system on first visit). */
export function getStoredThemePreference(): ThemePreference {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') return 'system';
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark' || stored === 'light' || stored === 'system') return stored;
  } catch {
    /* private mode */
  }
  return 'system';
}

export function resolveTheme(preference: ThemePreference): ResolvedTheme {
  if (preference === 'system') return getSystemTheme();
  return preference;
}

/** Resolved theme for initial paint (mirrors index.html bootstrap script). */
export function getInitialTheme(): ResolvedTheme {
  return resolveTheme(getStoredThemePreference());
}

export function applyResolvedTheme(resolved: ResolvedTheme): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (resolved === 'light') root.classList.add('light');
  else root.classList.remove('light');
}

/** Apply preference: resolve system, toggle `.light`, persist choice. */
export function applyThemePreference(preference: ThemePreference): void {
  applyResolvedTheme(resolveTheme(preference));
  try {
    localStorage.setItem(STORAGE_KEY, preference);
  } catch {
    /* private mode */
  }
}

/** @deprecated Use applyThemePreference */
export function applyTheme(theme: ResolvedTheme): void {
  applyResolvedTheme(theme);
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* private mode */
  }
}

/** Inline bootstrap for index.html — keep in sync with getInitialTheme(). */
export const THEME_BOOTSTRAP_SCRIPT = `(function(){try{var s=localStorage.getItem('da-theme');var light=false;if(s==='light')light=true;else if(s==='dark')light=false;else light=window.matchMedia&&window.matchMedia('(prefers-color-scheme: light)').matches;if(light)document.documentElement.classList.add('light');}catch(e){}})();`;
